require('./fileUpload.style.scss');

class FileUploadController {
    constructor($attrs, $filter) {
        this.labelText = this.labelText || 'fileUpload.file.label';
        this.inputName = this.inputName || 'upload-file';
        this.isRequired = this.isRequired || 'true';
        this.$attrs = $attrs;
        this.$filter = $filter;
        this.id = $attrs.eventId;

        if ($attrs.types) {
            this.typesValidation = JSON.parse(JSON.stringify($attrs.types));
            this.typesValidation = this.typesValidation.replace('.', '');
            this.typesValidation = this.typesValidation.split(',');
            if (this.typesValidation.length > 1) {
                for (let i = 1; i < this.typesValidation.length; i++) {
                    this.typesValidation[i] = '|' + this.typesValidation[i];
                }
            }
            this.patternMessage = this.$filter('translate')('fileUpload.file.pattern.error', {value: $attrs.types});
            this.typePattern = new RegExp(".(" + this.typesValidation +")$", "i");
        }
    }

    imported() {
        if(this.changed) this.changed();
    }
}

const fileUploadComponent = {
    restrict: 'E',
    controller: FileUploadController,
    template: require('./fileUpload.template.html'),
    bindings: {
        labelText: '@?',
        file: '=',
        name: '=',
        inputName: '@',
        form: '=',
        isRequired: '=',
        changed: '&?',
        readBinary: "<?",
        types: '@?'
    }
};

FileUploadController.$inject = ['$attrs', '$filter'];

module.exports = fileUploadComponent;



// WEBPACK FOOTER //
// ./src/shared/fileUpload/fileUpload.component.js